'use client'

import { initializePdfWorker } from '@/lib/pdfWorker'
import { useEffect } from 'react'

export function PdfWorkerProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initializePdfWorker()
  }, [])

  return <>{children}</>
}
